import { render, staticRenderFns } from "./IndexMediaImage.vue?vue&type=template&id=76020528&scoped=true&"
import script from "./IndexMediaImage.vue?vue&type=script&lang=js&"
export * from "./IndexMediaImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76020528",
  null
  
)

export default component.exports